<template>
  <div class="mobile_info" :class="{ white: isReverse }">
    <div class="item">{{ item.modelName }}</div>
    <hr class="line" :class="{ grey: isReverse }" />
    <div class="txt-box">
      <div class="ttl">
        <p>통신사</p>
        <p>월 요금</p>
        <p>지원금</p>
      </div>
      <div class="txt">
        <p class="telecom">{{ item.telecom }}</p>
        <p>{{ item.joinPlanPrice | comma }}원</p>
        <p class="red">{{ item.storeSupportMoney | comma }}원</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';

export default {
  name: 'component-mobile-detail-info',
  description: '휴대폰 상세 정보 컴포넌트',
  props: {
    item: Object,
    isReverse: {
      type: Boolean,
      default: false,
      description: 'default background color is grey color',
    },
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  methods: {},
};
</script>

<style></style>
